const centsToDollars = (amount) => parseFloat(amount || 0) / 100;

export const getSiteBudgetAndExpenditure = (dashboardData, trialSiteId) => {
  if (!dashboardData?.budgetBreakdown?.sitesBudget?.length || !trialSiteId) {
    return { totalBudget: 0, totalExpenditure: 0 };
  }

  const site = dashboardData.budgetBreakdown.sitesBudget.find(
    (entry) => entry.studySiteId === trialSiteId
  );

  if (!site) {
    return { totalBudget: 0, totalExpenditure: 0 };
  }

  const totalExpenditure = (site.siteExpenditure || []).reduce(
    (sum, entry) => sum + centsToDollars(entry.totalAmount),
    0
  );

  return {
    totalBudget: site.totalSiteBudget || 0,
    totalExpenditure: parseFloat(totalExpenditure.toFixed(2)),
  };
};
